
export function createCSV(data: [string, Status.Item][]){
  return data.map(([topic, message]) => {
    const topicItems = topic.split('/');
    return [
      topicItems[0],
      topicItems[2],
      message.eventTimestamp,
      message.journeyStatus,
      message.compliance,
      message.complianceFaults.join(','),
      message.totalDisplayCount,
      message.liveDisplayCount,
      message.expectedDisplayCount
    ].join('\t');
  }).join('\n');
}